import { render, staticRenderFns } from "./baseHome.vue?vue&type=template&id=bc673cc6"
import script from "./baseHome.vue?vue&type=script&lang=js"
export * from "./baseHome.vue?vue&type=script&lang=js"
import style0 from "./baseHome.vue?vue&type=style&index=0&id=bc673cc6&prod&lang=css"
import style1 from "./baseHome.vue?vue&type=style&index=1&id=bc673cc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports